import React, { useCallback } from 'react'

import { I18n } from '@front/volcanion'
import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'

import { Box, Typography, StepLabel, StepContent } from '@mui/material'

import Callbacks from './callbacks'
import Form from './Form'
import Header from './Header'
import Row from './Row'

const CompanyTemplateSection = ({ record_id }) => {
  const formToFilter = useCallback(Callbacks.formToFilterHandler(record_id), [record_id])
  const formToRecord = useCallback(Callbacks.formToRecordHandler(record_id), [record_id])
  const getEmptyForm = useCallback(Callbacks.getEmptyFormHandler(), [])

  return <>
    <StepLabel>
      <Typography variant='h5'>{I18n.t('export.label', { count: 2 })}</Typography>
    </StepLabel>
    <StepContent>
      <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
        <SearchFrame
          model_name={'companytemplate'}
          allowCreate={false}
          createPlacement={'bottom'}
        >
          <SearchForm
            formToFilter={formToFilter}
            submitOnMount
            disableButton
          >
            <FormContent><Form /></FormContent>
          </SearchForm>
          <SearchTable
            formProps={{
              formToRecord,
              getEmptyForm,
              disableParentSubmitListener: true,
              closeOnSuccess: true,
              submitChangesOnly: false
            }}
            tableProps={{
              onRowClick: null,
              allowEditMode: true,
              enablePagination: false,
              enableRowActions: true,
              enableGlobalActions: true,
              addRowLabel: I18n.t('export.label', { count: 2 }),
              enableGlobalActionsPlacement: 'bottom',
            }}
          >
            <TableHeader><Header /></TableHeader>
            <TableRow><Row /></TableRow>
          </SearchTable>
        </SearchFrame>
      </Box>
    </StepContent>
  </>
}

export default CompanyTemplateSection
